module.exports = __webpack_public_path__ + "static/media/apparelsIcon.76fa45e4.png";